import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=20d2127c&"
import script from "./AppBar.vue?vue&type=script&lang=ts&"
export * from "./AppBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports